export function formatDateTime(date, format) {
  if (format === undefined) {
    format = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }
  }

  return new Intl.DateTimeFormat('sl', format).format(date.toDate())
}
